import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import FeedbackResult from '../components/ScoreFeedback/FeedbackResult'

const ScoreFeedBackResult = () => {
  return (
    <>
        <Navbar />
        <FeedbackResult />
    </>
  )
}

export default ScoreFeedBackResult